export const EmptyState = () => (
	<div className="flex min-h-[2.5rem] items-center px-3 italic text-secondary">
		<div>There are no rows.</div>
	</div>
);
